// =====================================================================
// convenioService (S120) — chamadas do módulo Convênios / Controle de Glosa.
// isAuth; escopo = company do JWT. Gated convenio_module_enabled (403 se off).
// =====================================================================
import api from "./api";

const clean = (params = {}) => {
  const p = {};
  Object.keys(params).forEach((k) => {
    if (params[k] !== undefined && params[k] !== null && params[k] !== "") p[k] = params[k];
  });
  return { params: p };
};

export const listGuias = async (params) =>
  (await api.get("/convenio-glosas", clean(params))).data;
export const getSummary = async (params) =>
  (await api.get("/convenio-glosas/summary", clean(params))).data;
export const getConvenios = async () =>
  (await api.get("/convenio-glosas/convenios")).data;
export const createGuia = async (data) =>
  (await api.post("/convenio-glosas", data)).data;
export const updateGuia = async (id, data) =>
  (await api.put(`/convenio-glosas/${id}`, data)).data;
export const deleteGuia = async (id) =>
  (await api.delete(`/convenio-glosas/${id}`)).data;
export const importGuias = async (rows) =>
  (await api.post("/convenio-glosas/import", { rows })).data;
